<lx-form-field-selector
  [value]="value"
  [label]="label"
  valueExpr="code"
  [autofill]="autofill"
  [itemList]="weeksOptions"
  [disabled]="disabled"
  [required]="required"
  [placeholder]="placeholder"
  [iconValidation]="iconValidation"
  (valueChange)="valueChange.emit($event)"
  (itemChange)="itemChange.emit($event)"
></lx-form-field-selector>
